import TitleRevealHome from "./TitleRevealHome";

const TitleRevealHomeHolder = () => {
  return (
    <div className="title-holder">
        <div className="title">
            <h3>Sve što je Savremenu činilo drugačijom,</h3>
            <TitleRevealHome />
        </div>
        <p className="text">Posvećeni nastavnici, inovativan program, sredina u kojoj se svako dete oseća važnim — sada dobija prostor koji to sve nosi sa lakoćom. Novi prostor. Novo odeljenje. Prava škola za vaše dete.</p>
    </div>
  );
};

export default TitleRevealHomeHolder;